export default __webpack_public_path__ + "static/media/Left002.e8862bfc.png";